import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jam4m79k4y: FaireBrandEntity = {
  token: "b_jam4m79k4y",
  type: "brand",
  name: "Wild Dogwood Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/ec76dbe58e43c23a8ce4c75bc03c0a2735719b85b6ae1788c1f17c4b9d6b06e9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e8fe22e7186eb3ea36f606515ad80a75aa4f3218fce8766849d0678fb298ffcb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ec76dbe58e43c23a8ce4c75bc03c0a2735719b85b6ae1788c1f17c4b9d6b06e9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e8fe22e7186eb3ea36f606515ad80a75aa4f3218fce8766849d0678fb298ffcb.png",
  location: "Republic, MO, USA",
  minimumOrderDollars: 104,
  rating: 4.9,
  reviewCount: 19,
  isTopShop: true,
  isInsider: true,
  description:
    "At Wild Dogwood Designs, every charm necklace is more than just an accessory; it’s a heartfelt symbol of faith, hope, and inspiration. Founded with a passion for blending stories and spiritual growth, Wild Dogwood Designs was born out of a desire to help people wear and share their faith in a meaningful way. Each piece begins with a simple idea: a moment of grace captured in a charm. But the story doesn’t stop at the necklaces. Every design is accompanied by a carefully crafted display card, designed to complement the meaning behind each piece. These cards go beyond simple packaging—they tell a story. At Wild Dogwood Designs, we believe in the power of small things to make a big difference. Every necklace and card combination is designed to uplift, to speak to the soul, and to serve as a reminder that even in the smallest details, grace abounds.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:42.713Z",
    importedBy: "entity-db-cli",
  },
};
